module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"headline":"Купить","disabledMessage":"Для покупки необходимо принять условия правил"},"en":{"headline":"Buy","disabledMessage":"Для покупки необходимо принять условия правил"}}')
  delete Component.options._Ctor
}
